import { styled as r, IconButton as i, Tooltip as p } from "@mui/material";
import l from "../../temp-lib/components/share/next/Image.js";
import { DEFAULT_ALT as u } from "../../temp-lib/constants/layout.js";
import d from "../assets/icon-copy.svg.js";
import { useState as f, useCallback as y } from "react";
import { useTranslation as C } from "react-i18next";
import { jsx as o } from "react/jsx-runtime";
const g = r(i)`
  padding: unset;
`, T = r(l)`
  width: 18px;
  aspect-ratio: 1;
`, v = (s) => {
  const {
    className: c,
    value: e
  } = s, {
    t
  } = C(), [a, n] = f(""), m = y(() => {
    navigator.clipboard.writeText(e), n(t("common.button.copied")), setTimeout(() => {
      n(t("common.button.copy"));
    }, 2e3);
  }, [t, e]);
  return /* @__PURE__ */ o(p, {
    title: a,
    placement: "top",
    children: /* @__PURE__ */ o(g, {
      className: c,
      onClick: m,
      children: /* @__PURE__ */ o(T, {
        src: d,
        alt: u
      })
    })
  });
};
export {
  v as default
};
//# sourceMappingURL=CopyButton.js.map
